import { createSelector } from 'reselect';
import _get from 'lodash/get';
import { getLatestActivitySet } from 'lib/selectors/getLatestActivitySet';

const getLatestIdealUnitDuration = createSelector(
  [getLatestActivitySet],
  (latestActivitySet) => {
    return _get(latestActivitySet, 'idealUnitDuration');
  }
);

export { getLatestIdealUnitDuration };
